<template>
    <div class="wrapper starter-page">
        <h2 class="text-center">Your personal Race Management assistant</h2>
        <div class="d-flex justify-content-between flex-wrap-reverse">
            <div class="d-flex flex-wrap flex-row justify-content-around col-lg-8 col-md-12">
                <div>
                    <div class="info info-hover">
                        <div class="icon icon-success icon-circle">
                            <i class="fas fa-volume-up"></i>
                        </div>
                        <h4 class="info-title">Voice Announcements</h4>
                        <p class="description">Notifies you at 1 minute, 30 seconds, 20 seconds and gives a 10 second
                            countdown for each action.</p>
                    </div>
                </div>

                <div>
                    <div class="info info-hover">
                        <div class="icon icon-info icon-circle">
                            <i class="fas fa-flag-checkered"></i>
                        </div>
                        <h4 class="info-title">Flag Display</h4>
                        <p class="description">Visual display of current flag state as well as flags to be
                            displayed/removed next.</p>
                    </div>
                </div>

                <div>
                    <div class="info info-hover">
                        <div class="icon icon-primary icon-circle">
                            <i class="fas fa-sliders-h"></i>
                        </div>
                        <h4 class="info-title">Custom Start Sequences</h4>
                        <p class="description">Create own start sequences with different fleets.
                            Supports Rule 26, Appendix B 3.26.2 and (5-4-)3-2-1-Green.</p>

                    </div>
                </div>
                <div>
                    <div class="info info-hover">
                        <div class="icon icon-success icon-circle">
                            <i class="fas fa-clock"></i>
                        </div>
                        <h4 class="info-title">Scheduled Start</h4>
                        <p class="description">Start sequence on the next minute or schedule at specific time.</p>
                    </div>
                </div>

                <div>
                    <div class="info info-hover">
                        <div class="icon icon-warning icon-circle">
                            <i class="fas fa-wrench"></i>
                        </div>
                        <h4 class="info-title">Full Control</h4>
                        <p class="description">Abandon, Postpone races, issue Individual/General recall, add, (re)move future races on the fly.</p>
                    </div>
                </div>

                <div>
                    <div class="info info-hover">
                        <div class="icon icon-info icon-circle">
                            <i class="fas fa-flag"></i>
                        </div>
                        <h4 class="info-title">Finish Tracking</h4>
                        <p class="description">Mark when first/last boat finishes. Track time limits.</p>
                    </div>
                </div>
                <div>
                    <div class="info info-hover">
                        <div class="icon icon-success icon-circle">
                            <i class="fas fa-archive"></i>
                        </div>
                        <h4 class="info-title">Log</h4>
                        <p class="description">Saves all starts, including finish times.</p>
                    </div>
                </div>
                <div>
                    <div class="info info-hover">
                        <router-link to="/remote-horn/">
                        <div class="icon icon-primary icon-circle">
                            <i class="fas fa-bullhorn"></i>
                        </div>
                        <h4 class="info-title">Remote Horn</h4>
                        </router-link>
                        <p class="description">Automatic activation of you horn.</p>
                    </div>
                </div>
                <div>
                    <div class="info info-hover">
                        <div class="icon icon-warning icon-circle">
                            <i class="fas fa-ellipsis-h"></i>
                        </div>
                        <h4 class="info-title">More</h4>
                        <p class="description">See
                            <router-link to="/documentation">documentation page</router-link>
                            for all features.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="d-flex flex-column" style="padding: 20px;">
                    <img class="screenshot" src="/images/Main-Started.png" alt="Main Screen" v-rjs="3" style="max-width: 100%; height: auto"/>

                    <a class="d-block text-center"
                       href="https://apps.apple.com/app/voice-sail-start-timer/id1492557181?mt=8">
                        <img style="height: 60px" src="/images/Download_on_the_App_Store.svg" alt="App Store"/>
                    </a>
                  <p class="d-block text-center" style="padding-top: 60px"><b>Beta version:</b></p>
                    <a class="d-block text-center" href='https://play.google.com/store/apps/details?id=info.leonenko.starttimer'>
                      <img style="height: 80px" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                    </a>

                  <div class="d-block text-center" style="padding-top: 60px">
                  <KoFiButton
                      username="starttimer"
                      color="#00b9fe"
                      title="Support development"
                  />
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import KoFiButton from '@linusborg/vue-ko-fi-button'
    export default {
        components: {
          KoFiButton
        }
    }
</script>
<style lang="scss" scoped>
    .starter-page {
        min-height: calc(100vh - 159px);
    }

    .store-badge {
      height: 60px;
        //max-width: 300px;
    }

    .screenshot {
        margin: 0 0 25px;
    }
</style>
